export function InkDivider({ className = "" }: { className?: string }) {
	return (
		<svg
			className={`w-full overflow-visible ${className}`}
			height="24"
			viewBox="0 0 800 24"
			preserveAspectRatio="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<title>Decorative divider</title>
			<path
				d="M0,12 C40,4 80,20 120,12 C160,4 200,18 240,12 C280,6 320,18 360,12 C400,6 440,20 480,12 C520,4 560,18 600,12 C640,6 680,20 720,12 C760,4 800,16 800,12"
				stroke="#1a1209"
				strokeWidth="1.5"
				fill="none"
				opacity="0.4"
			/>
		</svg>
	);
}
